import { useState, type FormEvent } from "react";
import { signInWithMagicLink, supabaseConfigured } from "../auth";
import "./Login.css";

type Status =
  | { kind: "idle" }
  | { kind: "sending" }
  | { kind: "sent"; email: string }
  | { kind: "error"; message: string };

export function Login() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<Status>({ kind: "idle" });

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus({ kind: "sending" });
    try {
      await signInWithMagicLink(email.trim());
      setStatus({ kind: "sent", email: email.trim() });
    } catch (err) {
      const msg = err instanceof Error ? err.message : "Could not send the magic link.";
      setStatus({ kind: "error", message: msg });
    }
  };

  return (
    <div className="Login">
      <main className="Login__card">
        <h1 className="Login__title">Garden</h1>
        <p className="Login__subtitle">A quiet place for your plot.</p>

        {!supabaseConfigured && (
          <div className="Login__banner Login__banner--warn">
            Supabase isn't configured yet. Set <code>VITE_SUPABASE_URL</code> and{" "}
            <code>VITE_SUPABASE_ANON_KEY</code> in <code>apps/web/.env.local</code>.
          </div>
        )}

        {status.kind === "sent" ? (
          <div className="Login__banner Login__banner--ok">
            Check <strong>{status.email}</strong> for a magic link. It expires in an hour.
          </div>
        ) : (
          <form className="Login__form" onSubmit={onSubmit}>
            <label className="Login__field">
              <span className="Login__label">Email</span>
              <input
                type="email"
                required
                autoComplete="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={status.kind === "sending" || !supabaseConfigured}
              />
            </label>

            <button
              type="submit"
              className="Login__submit"
              disabled={status.kind === "sending" || !supabaseConfigured}
            >
              {status.kind === "sending" ? "Sending…" : "Send magic link"}
            </button>

            {status.kind === "error" && (
              <div className="Login__banner Login__banner--err">{status.message}</div>
            )}
          </form>
        )}
      </main>
    </div>
  );
}
